"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappersLegacyDefinition = void 0;
const services_definitions_1 = require("@wix/services-definitions");
exports.MappersLegacyDefinition = (0, services_definitions_1.defineService)('viewer-core/mappers-legacy');
//# sourceMappingURL=index.js.map